import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ModalService {
  private loading: HTMLIonLoadingElement;
  private present: Promise<void>;

  constructor(private loadingCtrl: LoadingController, private translate: TranslateService) {}

  presentLoading(text: string = 'static.loading'): Promise<any> {
    if (!this.loading) {
      return this.loadingCtrl
        .create({
          message: this.translate.instant(text)
        })
        .then(m => {
          this.loading = m;
          return (this.present = m.present());
        });
    } else {
      this.changeText(text);
      return this.present;
    }
  }

  changeText(text: string) {
    if (this.loading) {
      this.loading.message = this.translate.instant(text);
    }
  }

  dismissLoading(): Promise<any> {
    return this.loading
      ? this.loading.dismiss().then(() => {
          this.loading = null;
          this.present = null;
        })
      : Promise.resolve();
  }
}
